/**
 * @generated SignedSource<<70203034f2f7b3a9fb6b9e76b4ce618a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CityWalkTimeline_waypoints",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CityWalkTimelineWaypoint_waypoint"
    }
  ],
  "type": "CityWalkWaypoint",
  "abstractKey": null
};

node.hash = "756590563112cc4f2b6fd895d0896ca0";

module.exports = node;
